import { WallTypeEnum } from '../../interfaces/GenericInterfaces';
import { MovementOffsetDTO } from './MovementOffsetDTO';

export class WallMovementConstraintDTO {
  static defaultValue: WallMovementConstraintDTO[] = [
    new WallMovementConstraintDTO(
      WallTypeEnum.Floor,
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
    ),
    new WallMovementConstraintDTO(
      WallTypeEnum.Wall,
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
    ),
    new WallMovementConstraintDTO(
      WallTypeEnum.Ceiling,
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
      new MovementOffsetDTO(0, false),
    ),
  ];

  wallType: WallTypeEnum;
  topOffset: MovementOffsetDTO;
  bottomOffset: MovementOffsetDTO;
  leftOffset: MovementOffsetDTO;
  rightOffset: MovementOffsetDTO;
  linkVector?: number[];
  productOffset?: number;

  constructor(
    wallType: WallTypeEnum,
    topOffset: MovementOffsetDTO,
    bottomOffset: MovementOffsetDTO,
    leftOffset: MovementOffsetDTO,
    rightOffset: MovementOffsetDTO,
    linkVector?: number[],
    productOffset?: number,
  ) {
    this.wallType = wallType;
    this.topOffset = topOffset;
    this.bottomOffset = bottomOffset;
    this.leftOffset = leftOffset;
    this.rightOffset = rightOffset;
    this.linkVector = linkVector;
    this.productOffset = productOffset;
  }
}
